import { render, staticRenderFns } from "./AddressEditor.vue?vue&type=template&id=b20de7a4&scoped=true"
import script from "./AddressEditor.vue?vue&type=script&lang=js"
export * from "./AddressEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b20de7a4",
  null
  
)

export default component.exports